import React from "react";

const MobileIcon = (props: React.SVGProps<SVGSVGElement>) => (
  // <svg
  //   width="14"
  //   height="14"
  //   viewBox="0 0 14 14"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <path
  //     d="M10.9805 0.630859H4.98047C4.58315 0.632505 4.20257 0.791068 3.92163 1.07202C3.64068 1.35297 3.48211 1.73354 3.48047 2.13086V13.1309C3.48211 13.5282 3.64068 13.9088 3.92163 14.1897C4.20257 14.4707 4.58315 14.6292 4.98047 14.6309H10.9805C11.3778 14.6292 11.7584 14.4707 12.0393 14.1897C12.3203 13.9088 12.4788 13.5282 12.4805 13.1309V2.13086C12.4788 1.73354 12.3203 1.35297 12.0393 1.07202C11.7584 0.791068 11.3778 0.632505 10.9805 0.630859ZM7.98047 4.13086C7.83213 4.13086 7.68713 4.08687 7.56379 4.00446C7.44045 3.92205 7.34432 3.80492 7.28756 3.66787C7.23079 3.53083 7.21594 3.38003 7.24488 3.23454C7.27382 3.08906 7.34525 2.95542 7.45014 2.85053C7.55503 2.74564 7.68866 2.67421 7.83415 2.64527C7.97964 2.61633 8.13044 2.63118 8.26748 2.68795C8.40452 2.74472 8.52166 2.84084 8.60407 2.96418C8.68648 3.08752 8.73047 3.23252 8.73047 3.38086C8.73047 3.57977 8.65145 3.77054 8.5108 3.91119C8.37015 4.05184 8.17938 4.13086 7.98047 4.13086Z"
  //     fill="white"
  //   />
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="16"
    fill="none"
    viewBox="0 0 11 16"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.8"
      d="M4.25 3h2.5M9.072.5H1.928C1.14.5.5 1.172.5 2v12c0 .828.64 1.5 1.428 1.5h7.144c.789 0 1.428-.672 1.428-1.5V2c0-.828-.64-1.5-1.428-1.5"
    ></path>
  </svg>
);

export default MobileIcon;
